import React from 'react';
import { Select, Tag } from 'antd';
import { FieldLabel, ErrorText } from './styles';
import type { CategorySelectorProps } from './types';
import { PLACEHOLDERS } from './constants';

type TagProps = { label: React.ReactNode; onClose: () => void; closable: boolean };

const tagRender = (props: TagProps) => {
  const { label, onClose } = props;
  return (
    <Tag
      color="blue"
      closable
      onClose={onClose}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 10px',
        borderRadius: 20,
        fontSize: 13,
        fontWeight: 500,
        margin: '2px 4px 2px 0',
        lineHeight: '22px',
      }}
    >
      {label}
    </Tag>
  );
};

const CategorySelector: React.FC<CategorySelectorProps> = ({
  categories,
  selectedCategories,
  onCategoryChange,
  error,
}) => {
  const handleChange = (selectedIds: string[]) => {
    onCategoryChange(categories.filter((c) => selectedIds.includes(c.id)));
  };

  return (
    <div>
      <FieldLabel>Store Categories <span style={{ color: '#ff4d4f' }}>*</span></FieldLabel>
      <Select
        mode="multiple"
        showSearch
        allowClear
        tagRender={tagRender}
        placeholder={PLACEHOLDERS.SEARCH_CATEGORIES}
        value={selectedCategories.map((c) => c.id)}
        onChange={handleChange}
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        options={categories.map((c) => ({ value: c.id, label: c.category }))}
        style={{ width: '100%', minHeight: 40 }}
        status={error ? 'error' : ''}
      />
      {error && <ErrorText>{error}</ErrorText>}
    </div>
  );
};

export default React.memo(CategorySelector);
